import { Controller, useFormContext } from 'react-hook-form';

import { TextInput } from 'components/DesignSystem/TextInput';
import { FormProps } from 'components/widgets/CustomerProfile/CustomerProfile';

export const OpcUsername = () => {
    const methods = useFormContext<FormProps>();
    return (
        <Controller
            render={({ field }) => <TextInput {...field} label={'OPC Username'} />}
            name={`opcUsername`}
            control={methods.control}
        />
    );
};
